import { render, staticRenderFns } from "./NotificationButton.vue?vue&type=template&id=9f18a8ea&scoped=true&"
import script from "./NotificationButton.vue?vue&type=script&lang=js&"
export * from "./NotificationButton.vue?vue&type=script&lang=js&"
import style0 from "./NotificationButton.vue?vue&type=style&index=0&id=9f18a8ea&scoped=true&lang=css&"
import style1 from "./NotificationButton.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f18a8ea",
  null
  
)

export default component.exports